import Swiper, {Autoplay, Navigation, Pagination, EffectFade} from 'swiper';

Swiper.use([Autoplay, Navigation, Pagination, EffectFade]);

let uspsSwiper;
let learnMoreSwiper;

export default class Home {
    constructor() {
        if (document.getElementById('home') !== null) {
            // this.initHero();
            this.initSocial();
            this.propertySlider();
            this.reviewSlider();
            this.uspSlider();
            this.learnMoreSlider();
            this.nieuwbouwSlider();
        }
    }

    // initHero() {
    //     new Swiper('#hero .swiper-container', {
    //         slidesPerView: 1,
    //         allowTouchMove: false,
    //         autoplay: {
    //             delay: 2500,
    //         }
    //     });
    // }

    initSocial() {
        new Swiper('#social .swiper-container', {
            slidesPerView: 1,
            spaceBetween: 30,
            autoplay: {
                delay: 5000,
            },
            breakpoints: {
                576: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 3,
                },
                1200: {
                    slidesPerView: 4,
                }
            }
        });
    }

    reviewSlider() {
        if (document.querySelector('#reviews')) {
            new Swiper('#reviews .swiper-container', {
                slidesPerView: 1,
                spaceBetween: 20,
                // loop: true,
                autoplay: {
                    delay: 8000,
                },
                navigation: {
                    nextEl: '#reviews .swiper-button-next',
                    prevEl: '#reviews .swiper-button-prev',
                },
            });
        }
    }


    uspSlider() {
        function initSlider() {
            if (uspsSwiper === undefined && window.innerWidth < 992) {
                uspsSwiper = new Swiper('#usp-slider .swiper-container', {
                    slidesPerView: 1,
                    spaceBetween: 30,
                    loop: true,
                    modules: [Autoplay, Pagination],
                    pagination: {
                        el: '#usp-slider .swiper-pagination',
                        clickable: true,
                    },
                    autoplay: {
                        delay: 4500,
                    },
                });
            }
        }

        function destroySlider() {
            if (uspsSwiper !== undefined) {
                uspsSwiper.destroy(true, true);
                uspsSwiper = undefined;
            }
        }

        window.addEventListener('resize', function () {
            if (window.innerWidth < 992) {
                initSlider();
            } else {
                destroySlider();
            }
        });

        // Check initial window width
        if (window.innerWidth < 992) {
            initSlider();
        } else {
            destroySlider();
        }
    }


    learnMoreSlider() {
        if (document.querySelector('#learn-more .swiper-container')) {
            new Swiper('#learn-more .swiper-container', {
                slidesPerView: 1,
                spaceBetween: 30,
                loop: true,
                modules: [Autoplay, Pagination],
                pagination: {
                    el: '#learn-more .swiper-pagination',
                    clickable: true,
                },
                autoplay: {
                    delay: 4500,
                },
            });
        }
    }

    propertySlider() {
        if (document.querySelector('#properties-home')) {
            new Swiper('#properties-home .swiper-container', {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 30,
                breakpoints: {
                    360: {
                        slidesPerView: 1.2,
                        spaceBetween: 20
                    },

                    1024: {
                        slidesPerView: 3,

                    },
                    1200: {
                        slidesPerView: 3,

                    },
                }
            })
        }
    }


    resizeWindow() {
        let resizeTimer;
        window.addEventListener('resize', e => {
            if (resizeTimer) clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                this.reviewSlider();
                this.propertySlider();
            }, 100, e);
        });
    }


    nieuwbouwSlider() {
        if (document.getElementById('nieuwbouw-home')) {
            new Swiper('#nieuwbouw-home .swiper-container', {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 30,
                autoplay: {
                    delay: 3000,
                }
            })
        }
    }

}
